export const localStorageKeys = {
  SESSIONS_LEFT: 'SESSIONS_LEFT',
  USER_STATUS: 'USER_STATUS',
  CURRENT_PLAN_ID: 'CURRENT_PLAN_ID'
};
